import { useIntl } from 'react-intl';

import { SafeFormattedMessageWithoutSpread } from '../../../formatters';

import { $AccordionHeaderAdditionalContent } from './AccordionHeader.styles';
import messages from './messages';

interface AccordionAdditionalTitleContentProps {
  additionalTitleContent: string | number;
}

const isValidDateString = (str: string): boolean => {
  const date = new Date(str);

  return !isNaN(date.getTime()) && /^\d{4}-\d{2}-\d{2}/.test(str);
};

export const AccordionAdditionalTitleContent = ({
  additionalTitleContent,
}: AccordionAdditionalTitleContentProps) => {
  const { formatDate } = useIntl();

  if (!additionalTitleContent) {
    return null;
  }

  return (
    <$AccordionHeaderAdditionalContent>
      {typeof additionalTitleContent === 'string' &&
      isValidDateString(additionalTitleContent) ? (
        <div>
          <SafeFormattedMessageWithoutSpread
            message={messages.date}
            values={{
              date: formatDate(new Date(additionalTitleContent), {
                day: 'numeric',
                month: 'long',
                year: 'numeric',
              }),
            }}
          />
        </div>
      ) : (
        <>
          <SafeFormattedMessageWithoutSpread
            message={messages.items}
            values={{ count: Number(additionalTitleContent) }}
          />
        </>
      )}
    </$AccordionHeaderAdditionalContent>
  );
};
